import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../../context/auth/authContext";
import alt from "../../layouts/default.png";
import { Link } from "react-router-dom";
import ProfileUpload from "../../ProfilePhoto/ProfileUpload";
import "../../../styles/index.css";
import "../../../styles/fonts.css";
const EditAccount = (props) => {
  const authContext = useContext(AuthContext);
  const { currentUser, addError, loading, updateUserInfo } = authContext;
  const [info, setInfo] = useState({
    displayName: "",
    email: "",
    photoURL: "",
    bio: "",
    filepath: null,
    mobno: "",
    skills: [],
  });
  useEffect(() => {
    if (!currentUser) {
      addError(
        "The resource is visible only after authentication. Please log in."
      );
      props.history.push("/");
    } else {
      setInfo({
        ...info,
        displayName: currentUser.displayName,
        email: currentUser.email,
        photoURL: currentUser.photoURL,
        bio: currentUser.bio,
        mobno: currentUser.mobno,
        skills: currentUser.skills,
      });
    }

    //eslint-disable-next-line
  }, [loading, currentUser, props.history]);
  const [newItems, setNewItems] = useState({
    newSkill: null,
    newPreference: null,
  });
  const { newSkill } = newItems;
  const { displayName, photoURL, email, bio, filepath, mobno, skills } = info;
  const addSkill = () => {
    if (skills) {
      setInfo({ ...info, skills: [...skills, newSkill] });
    } else {
      setInfo({ ...info, skills: [newSkill] });
    }
    setNewItems({ ...newItems, newSkill: "" });
  };
  const deleteSkill = (e) => {
    console.log(e.target.name);
    skills.splice(e.target.name, 1);
    setInfo({ ...info, skills: skills });
  };
  const onChange = (e) => {
    setInfo({ ...info, [e.target.name]: e.target.value });
  };
  const onChangeNewItems = (e) => {
    setNewItems({ ...newItems, [e.target.name]: e.target.value });
  };
  const onSubmit = (e) => {
    e.preventDefault();
    updateUserInfo({
      displayName: displayName || "",
      photoURL: photoURL || "",
      bio: bio || "",
      mobno: mobno || "",
      filepath: filepath || null,
      skills: skills || [],
    });

    addError(
      "Successful! You might need to refresh the page for changes to take effect"
    );
    props.history.push(`viewaccount/${currentUser.uid}`);
  };
  return (
    <div
      className='row my-2 position-relative bg-light'
      style={{ top: "30px" }}
    >
      <div className='col-lg-5 order-lg-1 text-center'>
        <img
          src={photoURL || alt}
          className='mx-auto img-fluid img-circle d-block m-2'
          alt='avatar'
        />

        <ProfileUpload setInfo={setInfo} info={info} />
      </div>
      <div className='col-lg-7 order-lg-2'>
        <form>
          <div className='form-group row'>
            <label className='col-lg-3 col-form-label form-control-label fontcool size11'>
              User Name
            </label>
            <div className='col-lg-9'>
              <input
                className='form-control simplefont my-1   '
                type='text'
                name='displayName'
                placeholder='UserName...'
                value={displayName}
                onChange={onChange}
              />
            </div>
          </div>
          <div className='form-group row'>
            <label className='col-lg-3 col-form-label form-control-label fontcool size11'>
              About
            </label>
            <div className='col-lg-9'>
              <textarea
                className='form-control simplefont rounded'
                type='text'
                value={bio}
                name='bio'
                placeholder='Add a bio...'
                onChange={onChange}
                rows='3'
              ></textarea>
            </div>
          </div>
          <div className='form-group row'>
            <label className='col-lg-3 col-form-label form-control-label fontcool size11'>
              Email
            </label>
            <div className='col-lg-9'>
              <input
                className='form-control simplefont   '
                type='email'
                value={email}
                name='email'
                onChange={onChange}
                disabled
              />
            </div>
          </div>
          <div className='form-group row'>
            <label className='col-lg-3 col-form-label form-control-label fontcool size11'>
              Mobile Number
            </label>
            <div className='col-lg-9'>
              <input
                className='form-control simplefont'
                type='text'
                name='mobno'
                placeholder='add contact number...'
                value={mobno}
                onChange={onChange}
              />
            </div>
          </div>
          <div className='form-group row'>
            <label className='col-lg-3 col-form-label form-control-label fontcool size11'>
              Skills
            </label>
            <div className='col-lg-9'>
              <ul class='list-group'>
                {skills &&
                  skills.map((item, index) => (
                    <li
                      class='list-group-item d-flex simplefont  justify-content-between align-items-center'
                      key={index}
                    >
                      {item}{" "}
                      <input
                        type='button'
                        name={index}
                        value='&times;'
                        className='border-0 simplefont text-black'
                        aria-label='Close'
                        onClick={deleteSkill}
                      />
                    </li>
                  ))}
              </ul>
              <div className='input-group mt-2'>
                <input
                  className='form-control simplefont   '
                  type='text'
                  name='newSkill'
                  placeholder="Type a new skill and add it using '+' button"
                  value={newItems.newSkill || ""}
                  onChange={onChangeNewItems}
                />{" "}
                <div className='input-group-append'>
                  <button
                    type='submit'
                    className='btn btn-success slantfont size11'
                    data-dismiss='alert'
                    aria-label='Close'
                    onClick={addSkill}
                  >
                    <span aria-hidden='true' className='slantfont '>
                      &#43;
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          {currentUser && currentUser.providerId !== "google.com" && (
            <div className='form-group row'>
              <label className='col-lg-3 col-form-label form-control-label fontcool'>
                Password
              </label>
              <div className='col-lg-9'>
                <Link to='/reauthenticate/changepass'>
                  {" "}
                  <button
                    type='button'
                    className='btn btn-outline-primary slantfont'
                  >
                    Change Password?
                  </button>
                </Link>
              </div>
            </div>
          )}
          <div className='form-group row'>
            <input
              type='button'
              className='btn btn-outline-primary btn-block  slantfont'
              value='Save Changes'
              onClick={onSubmit}
            />
          </div>
          <div className='form-group d-flex justify-content-center'>
            {" "}
            <label className='col-lg-3 col-form-label text-danger form-control-label slantfont'>
              DANGER ZONE
            </label>
            <Link to='reauthenticate/delete'>
              <button className='btn btn-outline-danger slantfont'>
                Delete Account
              </button>
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditAccount;
